import * as classnames from 'classnames/bind'
import * as React from 'react'
import styled from 'styled-components'
import styles from './icon.scss'
const cx = classnames.bind(styles)

const IconContainer = styled.div<{ size?: number }>`
  width: ${props => props.style && props.style.width ? props.style.width : `${props.size || 24}px`};
  height: ${props => props.style && props.style.height ? props.style.height : `${props.size || 24}px`};
`

interface IProps extends React.HTMLProps<HTMLDivElement> {
  type: string
  size?: number
}
class Icon extends React.Component<IProps> {
  public render() {
    const { className, size, style, ...restProps } = this.props
    return (
      <IconContainer style={style} size={size} className={className} >
        <i
          {...restProps}
          className={cx('icon', `icon-${this.props.type}`, className)}
          aria-hidden="true"
        />
      </IconContainer>
    )
  }
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon/index.tsx